import { render } from "./Contacto.vue?vue&type=template&id=222bfa8e&scoped=true"
import script from "./Contacto.vue?vue&type=script&lang=js"
export * from "./Contacto.vue?vue&type=script&lang=js"

import "./Contacto.vue?vue&type=style&index=0&id=222bfa8e&scoped=true&lang=css"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222bfa8e"]])

export default __exports__